import { connect } from "react-redux"
import { Dispatch } from "redux"
import { RootState } from "../../../../reducers"
import { ActionDispatcher } from "../../actiondispacher/action-dispacher"

export interface IContainerProps {
  title: string | null
  actions: ActionDispatcher
}

const mapStateToProps = ({
  pages,
}: RootState): Omit<IContainerProps, "actions"> => ({
  title: pages.editor.currentEditingState.title,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: new ActionDispatcher(dispatch),
})

export const Container = connect(mapStateToProps, mapDispatchToProps)
